import styled from 'styled-components';

export const ProgressContainer = styled.nav`
  width: 100%;
  max-width: 760px;

  margin: var(--space-xl) auto;
`;

export const ProgressDesktop = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  padding: 0 var(--space-m);

  @media screen and (max-width: 700px) {
    display: none;
  }
`;

export const ProgressLine = styled.div`
  position: absolute;
  top: 18px;
  left: calc(12.5% + 18px);
  right: calc(12.5% + 18px);

  height: 3px;

  overflow: hidden;

  background: var(--grey1);

  border-radius: 100px;

  z-index: 0;
`;

export const ProgressLineFill = styled.div`
  width: ${({ $progress }) => `${$progress}%`};
  height: 100%;

  background: linear-gradient(90deg, var(--orange4), var(--yellow4));

  border-radius: inherit;

  transition: width 0.35s ease;
`;

export const ProgressStep = styled.button`
  position: relative;

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;

  margin: 0;
  padding: 0;

  background: transparent;

  border: 0;

  color: inherit;

  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  z-index: 1;

  &:focus-visible {
    outline: none;
  }

  &:focus-visible > div:first-child {
    outline: 3px solid rgba(234, 154, 38, 0.2);
    outline-offset: 4px;
  }

  ${({ $clickable, $active }) =>
    $clickable &&
    !$active &&
    `
      &:hover > div:first-child {
        transform: translateY(-2px);
      }
    `}
`;

export const ProgressStepCircle = styled.div`
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ $active, $completed }) => {
    if ($completed) return 'var(--yellow4)';
    if ($active) return 'var(--orange4)';

    return 'var(--white)';
  }};

  color: ${({ $active, $completed }) =>
    $active || $completed ? 'var(--white)' : 'var(--grey4)'};

  border: 2px solid
    ${({ $active, $completed }) => {
      if ($completed) return 'var(--yellow4)';
      if ($active) return 'var(--orange4)';

      return 'var(--grey2)';
    }};

  border-radius: 50%;

  box-shadow: ${({ $active }) =>
    $active ? '0 5px 14px rgba(234, 154, 38, 0.18)' : 'none'};

  font-size: 0.8rem;
  font-weight: 800;
  line-height: 1;

  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  svg {
    font-size: 0.65rem;
  }
`;

export const ProgressStepLabel = styled.span`
  color: ${({ $active, $completed }) => {
    if ($active) return 'var(--grey7)';
    if ($completed) return 'var(--grey6)';

    return 'var(--grey4)';
  }};

  font-size: 0.75rem;
  font-weight: ${({ $active }) => ($active ? 800 : 650)};
  letter-spacing: 0.01em;
  line-height: 1.3;
  text-align: center;

  transition: color 0.2s ease;
`;

export const ProgressMobile = styled.div`
  display: none;

  @media screen and (max-width: 700px) {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: var(--space-s);

    padding: 0 var(--space-m);
  }
`;

export const ProgressMobileHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-m);

  > div {
    min-width: 0;

    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    strong {
      overflow: hidden;

      color: var(--grey7);

      font-size: 1rem;
      font-weight: 800;
      line-height: 1.3;

      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  > span {
    flex: 0 0 auto;

    color: var(--orange4);

    font-size: 0.75rem;
    font-weight: 800;
    line-height: 1.2;
  }
`;

export const ProgressMobileMeta = styled.span`
  color: var(--grey4);

  font-size: 0.67rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  line-height: 1.2;
  text-transform: uppercase;
`;

export const ProgressMobileBar = styled.div`
  width: 100%;
  height: 5px;

  overflow: hidden;

  background: var(--grey1);

  border-radius: 100px;
`;

export const ProgressMobileFill = styled.div`
  width: ${({ $progress }) => `${$progress}%`};
  height: 100%;

  background: linear-gradient(90deg, var(--orange4), var(--yellow4));

  border-radius: inherit;

  transition: width 0.35s ease;
`;
